import { Link, useNavigate } from 'react-router-dom';
import './contacts-intro.scss';

const ContactsIntro: React.FC = () => {

  const navigate = useNavigate();
  
  // semplice check se il dispositivo è touch
  const isTouchDevice = typeof window !== 'undefined' && 'ontouchstart' in window;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isTouchDevice) {
      e.preventDefault(); // blocca il comportamento del Link
      setTimeout(() => {
        navigate('/contacts');
      }, 600); // delay di 1 secondo
    }
    // se non è touch, lascia fare al Link normalmente
  };


  return (
    <section
      id="contacts-intro"
      className="contacts-intro grid grid-cols-12 gap-0 flex flex-col items-center bg-dark text-light px-6 py-6 min-h-screen"
    >
      <p className="text-light-70">Let’s make things happen</p>
      <Link data-link-alt="Say hi" to={'/contacts'} onClick={handleClick}>
        <span>Contact me <span className='arrow'>→</span></span>
      </Link>
    </section>
  );
};

export default ContactsIntro;